import React from 'react';
import PermanentLicensesContainer from '../containers/permanentLicensesContainer';
import TemporaryLicensesContainer from '../containers/temporaryLicensesContainer';
import OfflineLicensesContainer from '../containers/offlineLicensesContainer';
import ClientsContainer from '../containers/clientsContainer';
import HistoryContainer from '../containers/historyContainer';
import ProductReleasesContainer from '../containers/productReleasesContainer';
import TrialLicensesContainer from '../containers/trialLicensesContainer';
import AdminHistoryContainer from '../containers/adminHistoryContainer';
import AccountsAIContainer from '../containers/accountsContainer';
import FeaturesContainer from '../containers/featuresContainer';
import DeviceFeaturesContainer from '../containers/deviceFeaturesContainer';
import TrialSettingsContainer from '../containers/trialSettingsContainer';
import WebViewerFeaturePackagesContainer from '../containers/webViewerFeaturePackagesContainer';
import WebViewerServersContainer from '../containers/webViewerServersContainer';
import WebViewerLicensesContainer from '../containers/webViewerLicensesContainer';
import BanContainer from '../containers/banContainer';

const mapping = {
  'permanent-licenses': PermanentLicensesContainer,
  'temporary-licenses': TemporaryLicensesContainer,
  'offline-licenses': OfflineLicensesContainer,
  'clients': ClientsContainer,
  'history': HistoryContainer,
  'product-releases': ProductReleasesContainer,
  'trial-licenses': TrialLicensesContainer,
  'admin-history': AdminHistoryContainer,
  'ai-accounts': AccountsAIContainer,
  'features': FeaturesContainer,
  'device-features': DeviceFeaturesContainer,
  'trial-settings': TrialSettingsContainer,
  'web-viewer-feature-packages': WebViewerFeaturePackagesContainer,
  'web-viewer-servers': WebViewerServersContainer,
  'web-viewer-licenses': WebViewerLicensesContainer,
  'ban': BanContainer,
};

const ComponentPage = (props) => {
  const { tab, tabs, ...restProps } = props;
  const Component = mapping[tab];
  if (!Component) return <h1>No such page</h1>;
  return <Component {...restProps}/>
};

export default ComponentPage;



// WEBPACK FOOTER //
// ./src/components/componentPage.js